/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Panel_LabelInputs */



/**
* | output |
* | --- |
* | "Quick tools panel" |
*
* @param {Quicktools_Panel_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_panel_label = /** @type {((inputs?: Quicktools_Panel_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Panel_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Panneau QuickTools")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schnellwerkzeug-Panel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pannello degli strumenti rapidi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Панель быстрых инструментов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Panel de herramientas rápidas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快速工具面板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クイックツールパネル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("त्वरित उपकरण पैनल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Painel de ferramentas rápidas")
	return /** @type {LocalizedString} */ ("Quick tools panel")
});